const CLASS_BLOCK_NAME = 'bb-score-board';
export const OPEN_BETS_CLASS_NAME = `${CLASS_BLOCK_NAME}--open-bets`;
export const SCORE_COLUMNS_CLASS_BLOCK_NAME = `${CLASS_BLOCK_NAME}__score-columns`;
export const SCORE_COLUMN_CLASS_BLOCK_NAME = `${CLASS_BLOCK_NAME}__score-column`;
export const SCORE_FIELD_CLASS_BLOCK_NAME = `${CLASS_BLOCK_NAME}__score-field`;
export const MATCH_STATUS_FIELD_CLASS_BLOCK_NAME = `${CLASS_BLOCK_NAME}__match-status`;
export const MATCH_STATUS_OPEN_BETS_CLASS_NAME = `${MATCH_STATUS_FIELD_CLASS_BLOCK_NAME}--open-bets`;

export const DEFAULT_HOME_CLASS_BLOCK_NAME = `${CLASS_BLOCK_NAME}__home`;
export const DEFAULT_AWAY_CLASS_BLOCK_NAME = `${CLASS_BLOCK_NAME}__away`;
export const MATCH_STATUS_CLASS_BLOCK_NAME = `${CLASS_BLOCK_NAME}__match-status`;

export const I18N_PREFIX = 'score_board';

export const FOOTBALL_SECOND_HALF_BREAK_MATCH_STATUS = 'AWAITING_OT';
export const FOOTBALL_FIRST_HALF_EXTRA_TIME_MATCH_STATUS = '1P_OT';
export const FOOTBALL_SECOND_HALF_EXTRA_TIME_MATCH_STATUS = '2P_OT';
export const FOOTBALL_SECOND_HALF_BREAK_TEXT = `${I18N_PREFIX}.ft`;
export const FOOTBALL_NORMAL_TIME_TEXT = `${I18N_PREFIX}.mins`;
export const FOOTBALL_EXTRA_TIME_TEXT = `${I18N_PREFIX}.mins_et`;
export const FOOTBALL_FIRST_HALF_TIME_IN_MINUTES = 45;
export const FOOTBALL_SECOND_HALF_TIME_IN_MINUTES = 90;
export const FOOTBALL_INJURY_TIME_TEXT = `${I18N_PREFIX}.mins_injury_t`;
export const FOOTBALL_PENALTIES_STATUS = 'PEN';
export const FOOTBALL_PENALTIES_TEXT = `${I18N_PREFIX}.penalties`;

export const GAA_EXTRA_TIME_IN_MINUTES = 70;
export const GAA_TIME_TEXT = `${I18N_PREFIX}.mins`;
export const GAA_EXTRA_TIME_TEXT = `${I18N_PREFIX}.mins_injury_t`;

export const FIRST_HALF_BREAK_TEXT = `${I18N_PREFIX}.ht`;
export const FIRST_HALF_BREAK_MATCH_STATUS = 'PAUSED';
export const FIRST_HALF_MATCH_STATUS = '1P';
export const SECOND_HALF_MATCH_STATUS = '2P';
export const FIRST_HALF_TEXT = `${I18N_PREFIX}.first_half`;
export const SECOND_HALF_TEXT = `${I18N_PREFIX}.second_half`;

export const ABOUT_TO_START = 'about_to_start';

export const SET_TEXT = `${I18N_PREFIX}.set`;
export const SET_SERVER_ONE = '1';
export const SET_SERVER_TWO = '2';
export const SET_CURRENT_SCORE_MODIFIER = 'set-current-score';
export const SET_CURRENT_SERVER_MODIFIER = 'set-current-server';
export const SET_SERVER_MODIFIER = 'set-server';
export const PAST_SET_SCORE = 'past-set-score';
export const SCORE_IN_SETS = 'score-in-sets';

export const GAME_TEXT = `${I18N_PREFIX}.game`;

export const DARTS_SET_CODE = 'set';
export const DARTS_LEG_CODE = 'leg';
export const DARTS_ENDED_CODE = 'ended';
export const DARTS_LEGS_MODIFIER = 'darts-legs';

export const CRICKET_NO_MATCH_DEFAULT_SCORE = '0/0';
export const CRICKET_BATTING_MODIFIER = 'cricket-batting';
export const CRICKET_AWAY_TEAM = 'away';
export const CRICKET_TEST_CRICKET = 'test_cricket';

export const SNOOKER_STATUS_FRAME_TEXT = `${I18N_PREFIX}.frame_[n]`;

export const BOXING_STATUS_ROUND_TEXT = `${I18N_PREFIX}.round_[x]_[mins]`;

export const DARTS_LEG_STATUS_TEXT = `${I18N_PREFIX}.leg_[n]`;
export const DARTS_SET_STATUS_TEXT = `${I18N_PREFIX}.set`;
export const DARTS_GAME_ON_STATUS_TEXT = `${I18N_PREFIX}.game_on`;
export const DARTS_ENDED_STATUS_TEXT = `${I18N_PREFIX}.ended`;

export const CRICKET_STATUS_TEXT = `${I18N_PREFIX}.inning_[n]`;

export const VOLLYBALL_STATUS_PAUSED_TEXT = `${I18N_PREFIX}.pause`;
export const VOLLYBALL_STATUS_TEXT = `${I18N_PREFIX}.set`;

export const SPORT_QUARTER_STATUS_TEXT = `${I18N_PREFIX}.sport_status_quarter`;
export const SPORT_QUARTER_ONLY_TEXT = `${I18N_PREFIX}.sport_status_quarter_only`;
export const SPORT_MINUTES_TEXT = `${I18N_PREFIX}.mins`;
export const SPORT_PERIOD_ONLY_TEXT = `${I18N_PREFIX}.sport_status_period_only`;
export const SPORT_OVERTIME_STATUS_TEXT = `${I18N_PREFIX}.sport_status_overtime_only`;
export const SPORT_OVERTIME = 'OT';

export const ICE_HOCKEY_MINS_STATUS_TEXT = `${I18N_PREFIX}.mins`;
export const ICE_HOCKEY_STATUS_TEXT = `${I18N_PREFIX}.sport_status_period`;
export const ICE_HOCKEY_ENDED_STATUS_TEXT = `${I18N_PREFIX}.ft`;
export const ICE_HOCKEY_PAUSED_STATUS_TEXT = `${I18N_PREFIX}.pause`;
export const ICE_HOCKEY_OVERTIME_STATUS_TEXT = `${I18N_PREFIX}.mins_ot`;
export const ICE_HOCKEY_PENALTIES_STATUS_TEXT = `${I18N_PREFIX}.penalties`;
export const HANDBALL_PENALTIES = 'PEN';
export const HANDBALL_FULLTIME = 'ENDED';
export const HANDBALL_HALFTIME = 'PAUSE1';
export const HANDBALL_PENALTIES_I18N_KEY = `${I18N_PREFIX}.penalties`;
export const HANDBALL_FT_I18N_KEY = `${I18N_PREFIX}.ft`;
export const HANDBALL_HT_I18N_KEY = `${I18N_PREFIX}.ht`;
export const HANDBALL_NORMAL_TIME_I18N_KEY = `${I18N_PREFIX}.sport_status_period`;

export const ICE_HOCKEY_PAUSED = 'PAUSE';
export const ICE_HOCKEY_ENDED = 'ENDED';
export const ICE_HOCKEY_PAUSED_STATUS = 'INT';
export const ICE_HOCKEY_OVERTIME = 'OT';
export const ICE_HOCKEY_ENDED_STATUS = 'FT';
export const ICE_HOCKEY_PENALTIES = 'PEN';

export const ICE_HOCKEY_AFTER_OVERTIME = 'AFTER_OT';

export const ESPORTS_DECIDER = 'DECIDER';
export const ESPORTS_STATUS = `${I18N_PREFIX}.esports_status`;
export const ESPORTS_DECIDER_STATUS = `${I18N_PREFIX}.esports_decider`;

export const MMA_ROUND_I18N_KEY = `${I18N_PREFIX}.round_[x]`;

export const FOOTBALL = 'football';
export const GAA_HURLING = 'gaa-hurling';
export const GAA_FOOTBALL = 'gaa-football';
export const MMA = 'mma';
export const RUGBY_LEAGUE = 'rugby-league';
export const RUGBY_UNION = 'rugby-union';
export const TENNIS = 'tennis';
export const BADMINTON = 'badminton';
export const TABLE_TENNIS = 'table-tennis';
export const BASKETBALL = 'basketball';
export const ICE_HOCKEY = 'ice-hockey';
export const AMERICAN_FOOTBALL = 'american-football';
export const AUSTRALIAN_RULES = 'australian-rules';
export const SNOOKER = 'snooker';
export const BOXING = 'boxing';
export const DARTS = 'darts';
export const CRICKET = 'cricket';
export const GOLF = 'golf';
export const BASEBALL = 'baseball';
export const HANDBALL = 'handball';
export const VOLLEYBALL = 'volleyball';
export const ESPORTS = 'esports';
export const MOTORSPORT = 'motor-racing';
